import React, {
    useContext,
} from 'react';
import { useNavigate } from "react-router";
import { format } from "date-fns";
import { useMutation } from '@tanstack/react-query';

import { getCustomer, NotificationContext, handleError } from '../router';

import * as QUERIES from "../query-functions";
import LoadingIndicator from '../components/loading-indicator';

const CustomerMemberhips = () => {

    const {notification, setNotification} = useContext(NotificationContext);

    let navigate = useNavigate();

    const { data: customer } = getCustomer();

    const addMembership = useMutation({
        mutationFn: (membershipId) => QUERIES.addMembership([{membership: membershipId, autoRenew: true}]),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: () => {
            navigate(`/basket`);
        },
    });

    if (!customer?.subscriptions) return null;

    return (
        customer.subscriptions.map((membership) => {
            if (!membership.membership.id) return;
            if (membership.membership.attribute_ExcludeFromCustomerAccountArea) {
                return null;
            }
            const expiry_date = format(membership.expiryDate, "EEE d MMM yyyy");
            return (
                <section key={membership.membership.id} className='customer-membership'>
                    <h2 className='booking-pathway__header'>
                        You are {/^[aeiou]/i.test(membership.membership.name) ? 'an' : 'a'} {membership.membership.name}
                    </h2>
                    <p className='customer-membership__info'>Membership expires on {expiry_date}</p>
                    {membership.canRenew &&
                        <button type="button" className='btn' onClick={() => addMembership.mutateAsync(membership.membership.id)}>
                            Renew
                            {addMembership.isPending &&
                                <LoadingIndicator />
                            }
                        </button>
                    }
                </section>
        )})
    );
};

export default CustomerMemberhips;